export var ContestResultType;
(function (ContestResultType) {
    ContestResultType["CLOSEST_TO_PIN"] = "closestToPin";
    ContestResultType["LONGEST_DRIVE"] = "longestDrive";
    ContestResultType["STRAIGHTEST_DRIVE"] = "straightestDrive";
})(ContestResultType || (ContestResultType = {}));
